module.exports = __webpack_public_path__ + "img/preview_icon.3e2e0184.png";